var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasBreadcrumb && _vm.breadcrumbData && _vm.breadcrumbData.length < 2)?_c('div',[_c('h3',{staticClass:"pageTitle"},[_vm._v(_vm._s(_vm.breadcrumbData[_vm.breadcrumbData.length-1].title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }